import type { ReactNode } from "react";

import { AMP_UNMASK_PROPS } from "shell/platform/lib/analytics/amplitudePrivacy";

import type { MenuItem } from "../types";

type LabeledMenuItem = {
  children?: MenuItem[];
  label?: ReactNode;
  type?: string;
};

/**
 * Tags main-menu labels as safe for Session Replay. Only the shell navigation
 * is opted in: the user menu, filter menus and page content stay masked under
 * the conservative default.
 */
export const markMenuLabelsForReplay = (items: MenuItem[]): MenuItem[] =>
  items.map(item => {
    const menuItem = item as LabeledMenuItem | null;

    if (!menuItem || menuItem.type === "divider") return item;

    const { children, label } = menuItem;

    const markedLabel =
      label === null || label === undefined ? (
        label
      ) : (
        <span {...AMP_UNMASK_PROPS}>{label}</span>
      );

    return {
      ...item,
      label: markedLabel,
      ...(children ? { children: markMenuLabelsForReplay(children) } : {}),
    } as MenuItem;
  });
